<div class="newsletter-container border-lighter">
    <div class="newsletter-content py-5">
        <div class="item-left flex-col"> 
            <h2 class="uppercase">Subscribe to our Newsletter</h2>
            <span class="desc mb-1">Stay up to date with our latest news and properties</span>
        </div>
        <form [formGroup]="subscribeForm" (ngSubmit)="onSubscribeFormSubmit(subscribeForm.value)" class="item-right">
            <div class="fieldContainer">
                <mat-form-field floatLabel="always" subscriptSizing="dynamic" class="w-100" appearance="outline" color="primary">
                    <input matInput autocomplete="off" formControlName="email" placeholder="Your Email Address">
                    <button mat-flat-button matSuffix type="submit" class="mr-2" color="primary" [disabled]="!canSubscribe">Subscribe</button>                    
                </mat-form-field>
            </div>

        </form>
    </div>
</div>              
